<template>
    <div @click="close" aria-hidden="true" class="popup popup_show">
        <div class="popup__wrapper">
            <div class="popup__content">
                <button @click="close" type="button" class="popup__close">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#close"></use>
                    </svg>
                </button>
                <div class="popup__col popup__col_left">
                    <div class="popup__image-ibg">
                        <img loading="lazy" :src="data.url" />
                    </div>
                </div>
                <div class="popup__col popup__col_right">
                    <form class="popup__form form-feedback">
                        <div class="h3 form-feedback__title">{{ trans('home.submit_your_application') }}</div>
                        <fieldset class="form-feedback__fieldset">
                        <div class="form-feedback__line">
                            <label class="form-feedback__input-label">
                            <span>{{ trans('home.name') }}</span>
                            <input
                                v-model="name"
                                data-required
                                autocomplete="off"
                                type="text"
                                name="name"
                                :placeholder="trans('home.you_name')"
                                class="input form-feedback__input"
                            />
                            </label>
                        </div>
                        <div class="form-feedback__line">
                            <label class="form-feedback__input-label">
                            <span>{{ trans('home.phone') }}</span>
                            <input
                                v-model="phone"
                                data-required
                                type="tel"
                                name="tel"
                                placeholder="+380"
                                class="input form-feedback__input"
                            />
                            </label>
                        </div>
                        <div class="form-feedback__line">
                            <label class="form-feedback__input-label">
                            <span>Email</span>
                            <input
                                v-model="email"
                                data-required="email"
                                type="email"
                                name="email"
                                :placeholder="trans('home.you_email')"
                                class="input form-feedback__input"
                            />
                            </label>
                        </div>
                        <div class="form-feedback__line">
                            <label class="form-feedback__input-label">
                            <span>{{ trans('home.comment') }}</span>
                            <textarea
                                v-model="comment"
                                data-required
                                autocomplete="off"
                                name="text"
                                :placeholder="trans('home.your_whishes_to_order')"
                                class="input form-feedback__input"
                            ></textarea>
                            </label>
                        </div>
                        </fieldset>
                        <p v-html="message" class="inst-form-error-desc-mob"></p>
                        <button @click.prevent="send" type="submit" class="form-feedback__button button btn">
                            {{ trans('home.submit_your_application') }}
                        </button>
                    </form>
                    <p v-html="message" class="inst-form-error-desc"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    props: {
        data: {
            required: true,
            default: false,
        },
    },
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            comment: '',
            message: '',
        }
    },
    methods: {
        close(event) {
            if (
                !event.target.closest(".popup__content") ||
                event.target.closest(".popup__close")
            ) {
                this.$emit("close");
            }
        },
        send() {
            axios({
                method: "post",
                url: window.globalVariables.locale + "/feedback/instagram/new",
                data: { 
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    comment: this.comment,
                    link: this.data.url,
                    thumb_id: this.data.thumb_id
                }
            })
            .then(response => {
                if(response.data.status == 'success') {
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.comment = '';
                    this.message = this.trans('home.request_is_sent')
                }
            })
            .catch(error => {
                this.message = error.response.data.error;
            });
        },
    },
};
</script>